import { useCallback } from 'react';

// Extremely dummy hook which ensures callbacks provided to a modal always return undefined.
export default function(fn, deps) {
  return useCallback(() => {
    fn();
    return;
  }, [fn]);
}
